import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dd14fba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "templatePreviewModal",
  tabindex: "-1",
  "aria-labelledby": "templatePreviewModallabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = {
  key: 0,
  class: "modal-content shadow-none"
}
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_customer_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_modal_add_customer_close\" data-bs-dismiss=\"modal\" class=\"btn btn-icon btn-sm btn-active-icon-primary\" data-v-0dd14fba><span class=\"svg-icon svg-icon-1\" data-v-0dd14fba><i class=\"fs-3 el-icon el-dialog__close\" data-v-0dd14fba><svg viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0dd14fba><path fill=\"currentColor\" d=\"M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z\" data-v-0dd14fba></path></svg></i></span></div>", 1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  id: "template-preview",
  "aria-haspopup": "true",
  class: "col-md-12"
}
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table align-middle fs-6 gy-3 table-bordered" }
const _hoisted_12 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DrawComponent = _resolveComponent("DrawComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.formStructureVal.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.name), 1),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("table", _hoisted_11, [
                      _createElementVNode("tbody", null, [
                        (_ctx.formStructureVal?.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formStructureVal, (row, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index,
                                id: row.key
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.columns, (col, colIndex) => {
                                  return (_openBlock(), _createElementBlock("td", _mergeProps({ key: colIndex }, col.attrs, { class: "border" }), [
                                    _createElementVNode("div", _mergeProps({ class: `d-flex flex-wrap align-items-center` }, row.rowProp), [
                                      (col.components.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(col.components, (component, compIndex) => {
                                            return (_openBlock(), _createBlock(_component_DrawComponent, {
                                              key: compIndex,
                                              component: component,
                                              isDraggable: false,
                                              isPreview: true
                                            }, null, 8, ["component"]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ], 16)
                                  ], 16))
                                }), 128))
                              ], 8, _hoisted_12))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}